"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateURL = exports.generateUSMXESGApproachLearnMoreUrl = exports.generateESGLearnMoreUrl = exports.generateESGFindOutMoreUrl = exports.getDocumentsByCategory = exports.generateCostAndChargesUrl = exports.generateFundDocLink = exports.getSummaryProspectusURL = exports.getRegulatoryDocumentLinks = exports.getLanguageOverrideForJumpToFundResults = exports.generateKIIDURLForNonUSCountry = exports.generateKIDUrl = exports.generateFactSheetURLForNonUSCountry = exports.getDFSSiteForRole = exports.getCADFSURL = exports.getDFSURL = undefined;
exports.getCommingledRegulatoryDocumentLinks = getCommingledRegulatoryDocumentLinks;

var _constants = require("../../../packages/common-utilities/src/constants.js");

var _constants2 = _interopRequireDefault(_constants);

var _ramda = require("ramda");

var _functional_utility = require("./functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var REGULATORY_DOCUMENT_URL = "https://am.jpmorgan.com/JPMorgan/TADF/";
var REGULATORY_DOCUMENT_URL_US = "https://am.jpmorgan.com/JPMorgan/TVT/";
var CA_REGULATORY_DOCUMENT_URL_US = "https://am.jpmorgan.com/jpmorganca/TVT/";
var SIXCIRCLES_REGULATORY_DOCUMENT_URL = "https://www.sixcirclesfunds.com/JPMorgan/TADF/";
var DFS_REGULATORY_DOCUMENT_URL = "https://connect.rightprospectus.com/JPMorgan/TVT/";
var REGULATORY_DOCUMENT_CATEGORIES = {
  "Summary Prospectus": "SP",
  "Prospectus": "P",
  "Annual Report": "AR",
  "Annual Financial Statements and Other Information": "NCSR",
  "Semi Annual Report": "SAR",
  "Semi-Annual Financial Statements and Other Information": "NCSRS",
  "First Quarter Holdings": "QH1",
  "Third Quarter Holdings": "QH3",
  "Statement of Additional Information": "S",
  "Annual Report Of Proxy Voting": "NPX"
};

var COUNTRY_LANGUAGE_OVERRIDE_MAPPINGS_FOR_JTF = {
  "CN": "cn"
};

var COUNTRY_LANGUAGE_OVERRIDE_MAPPINGS = {
  "SE": "SV",
  "DK": "DA",
  "NO": "NO",
  "NL": "NL"
};

var LANGUAGE_COUNTRY_OVERRIDE_MAPPINGS = {
  "SV": "SE"
};

var COMMINGLED_REGULATORY_DOCUMENT_CATEGORIES = {
  "Annual Shareholder Report": "AR",
  "Declaration of Trust": "DOT",
  "Fund Summary": "FSD"
};

var COMMINGLED_REGULATORY_DOCUMENT_CATEGORIES_INSTI = {
  "Fund Summary": "FSD"
};

var UrlUtility = {
  getDFSURL: function getDFSURL(identifier, category, role) {
    if (role === _constants2.default.getOrionRole()) {
      return DFS_REGULATORY_DOCUMENT_URL + identifier + '/' + category + "?site=" + getDFSSiteForRole(role);
    } else if (role === _constants2.default.getSixcirclesRole()) {
      return SIXCIRCLES_REGULATORY_DOCUMENT_URL + identifier + '/' + category + "?site=" + getDFSSiteForRole(role);
    } else {
      var updatedURL = role === _constants2.default.getAccessFundsRole() ? REGULATORY_DOCUMENT_URL : REGULATORY_DOCUMENT_URL_US;
      return updatedURL + identifier + '/' + category + "?site=" + getDFSSiteForRole(role);
    }
  },
  getCADFSURL: function getCADFSURL(cusip, language, category) {
    var cusipSuffixMap = {
      en: {
        cusipSuffix: 'E',
        queryString: ''
      },
      fr: {
        cusipSuffix: 'F',
        queryString: '?site=FR'
      }
    };
    var cusipSuffixMapElement = cusipSuffixMap[language] || {};
    return "" + CA_REGULATORY_DOCUMENT_URL_US + cusip + cusipSuffixMapElement.cusipSuffix + "/" + category + cusipSuffixMapElement.queryString;
  },
  getDFSSiteForRole: function getDFSSiteForRole(role) {
    if (role === _constants2.default.getAccessFundsRole()) {
      return "JPMAccess";
    } else if (role === _constants2.default.getSixcirclesRole()) {
      return "SixCirclesFunds";
    }
    return "JPMorganv3";
  },
  generateFactSheetURLForNonUSCountry: function generateFactSheetURLForNonUSCountry(shareClassId, country, role) {
    var language = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en";

    if (role.toUpperCase() === 'LIQ') {
      if (country.toUpperCase() === 'GB') {
        return 'https://jp.techrules.com/rebrandingPDF/LoadPdf.aspx?ShareClassId=' + shareClassId + '&country=GB&lang=EN&paramMIFID=YES';
      } else {
        return 'https://jp.techrules.com/rebrandingPDF/LoadPdf.aspx?ShareClassId=' + shareClassId + '&country=LU&lang=EN&paramMIFID=YES';
      }
    } else if (role.toUpperCase() === 'INSTITUTIONAL' && language.toUpperCase() === "EN" && country.toUpperCase() !== 'GB' && country.toUpperCase() !== 'CH' && country.toUpperCase() !== 'LU') {
      return 'https://jp.techrules.com/rebrandingPDF/LoadPdf.aspx?ShareClassId=' + shareClassId + '&country=LU&lang=EN&paramMIFID=YES';
    } else if ((role.toUpperCase() === 'ML' || role.toUpperCase() === 'NRA') && country.toUpperCase() === 'LU') {
      return 'https://jp.techrules.com/rebrandingPDF/LoadPdf.aspx?ShareClassId=' + shareClassId + '&country=AR&lang=' + language.toUpperCase() + '&paramMIFID=YES';
    } else {
      var countryOverride = LANGUAGE_COUNTRY_OVERRIDE_MAPPINGS[language.toUpperCase()];
      if (!(0, _ramda.isNil)(countryOverride)) {
        country = countryOverride;
      }
      var languageOverride = COUNTRY_LANGUAGE_OVERRIDE_MAPPINGS[country.toUpperCase()];
      if (!(0, _ramda.isNil)(languageOverride)) {
        language = languageOverride;
      }
      return "https://jp.techrules.com/rebrandingPDF/LoadPdf.aspx?ShareClassId=" + shareClassId + "&country=" + country.toUpperCase() + "&lang=" + language.toUpperCase() + "&paramMIFID=YES";
    }
  },
  getLanguageOverrideForJumpToFundResults: function getLanguageOverrideForJumpToFundResults(country) {
    return COUNTRY_LANGUAGE_OVERRIDE_MAPPINGS_FOR_JTF[country.toUpperCase()];
  },
  generateCostAndChargesUrl: function generateCostAndChargesUrl(isin) {
    return 'https://wl.fundsquare.net/serv/down-doc/request?cdClient=JPMorganAM&isin=' + isin.toUpperCase() + '&docTypeCode=KFSD&docLang=EN&docCountry=GB';
  },
  generateKIDUrl: function generateKIDUrl(isin, country, role) {
    var language = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en";
    var gaiaRedirectUrl = arguments[4];

    return gaiaRedirectUrl + "/document-redirect/" + isin + "?country=" + country + "&language=" + language + "&role=" + role + "&documentCategory=" + _constants2.default.getKidCMSDocumentCategory();
  },
  generateKIIDURLForNonUSCountry: function generateKIIDURLForNonUSCountry(isin, country, role) {
    var language = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en";

    var docType = 'KIDD';
    if (country.toUpperCase() === 'GB') {
      docType = 'KIID';
    }
    if (role.toUpperCase() === 'LIQ' && country.toUpperCase() !== 'GB' && country.toUpperCase() !== 'CH') {
      country = 'LU';
      language = 'EN';
    } else if (role.toUpperCase() === 'INSTITUTIONAL' && language.toUpperCase() === "EN" && country.toUpperCase() !== 'GB' && country.toUpperCase() !== 'CH' && country.toUpperCase() !== 'LU') {
      country = 'LU';
      language = 'EN';
    } else if ((role.toUpperCase() === 'ML' || role.toUpperCase() === 'NRA') && country.toUpperCase() === 'LU') {
      if (language.toUpperCase() === "ES") {
        country = 'ES';
      } else if (language.toUpperCase() === "PT") {
        return null;
      }
    } else {
      var countryOverride = LANGUAGE_COUNTRY_OVERRIDE_MAPPINGS[language.toUpperCase()];
      if (!(0, _ramda.isNil)(countryOverride)) {
        country = countryOverride;
      }
      var languageOverride = COUNTRY_LANGUAGE_OVERRIDE_MAPPINGS[country.toUpperCase()];
      if (!(0, _ramda.isNil)(languageOverride)) {
        language = languageOverride;
      }
    }
    return "https://wl.fundsquare.net/serv/down-doc/request?cdClient=jpmorgan&isin=" + isin.toUpperCase() + "&docTypeCode=" + docType + "&docLang=" + language.toUpperCase() + "&docCountry=" + country.toUpperCase();
  },
  getRegulatoryDocumentLinks: function getRegulatoryDocumentLinks(identifier, role) {
    return getRegulatoryDocsBasedOnFundType(identifier, role, REGULATORY_DOCUMENT_CATEGORIES);
  },
  getSummaryProspectusURL: function getSummaryProspectusURL(identifier, role) {
    return getDFSURL(identifier, REGULATORY_DOCUMENT_CATEGORIES['Summary Prospectus'], role);
  },
  getProspectusURL: function getProspectusURL(identifier, role) {
    return getDFSURL(identifier, REGULATORY_DOCUMENT_CATEGORIES['Prospectus'], role);
  },
  generateFundDocLink: function generateFundDocLink(country, language, role, isAEM) {
    var fundDocURL = _constants2.default.getFundDocumentsUrl();
    if (isAEM) {
      fundDocURL = _constants2.default.getAEMFundDocumentsUrl();
    }

    return fundDocURL.replace("<COUNTRYCODE>", country.toLowerCase()).replace("<LANGCODE>", language.toLowerCase()).replace("<ROLECODE>", role.toLowerCase());
  },
  getDocumentsByCategory: function getDocumentsByCategory(fundDocuments, category) {
    var doc = {};
    if (!(0, _functional_utility.isNilOrEmpty)(fundDocuments)) {
      fundDocuments.forEach(function (document) {
        if ((0, _ramda.includes)(category, (0, _ramda.pathOr)([], ['docCategories'], document))) {
          doc = document;
        }
      });
    }
    return doc;
  },
  generateESGFindOutMoreUrl: function generateESGFindOutMoreUrl(country, language, role) {
    var formattedRole = role ? role.toLowerCase() : role;
    var formattedLanguage = language ? language.toLowerCase() : language;
    var formattedCountry = country ? country.toLowerCase() : country;

    var esgURL = _constants2.default.getESGInvestmentThemesSustainableInvestingUrl();

    if ((0, _ramda.or)(formattedRole === 'adv' && formattedLanguage === 'fr', formattedRole === 'per' && formattedCountry !== 'it')) {
      esgURL = _constants2.default.getESGInvestmentThemesEsgUrl();
    }

    if (formattedRole === 'institutional') {
      esgURL = _constants2.default.getESGInvestmentStrategiesSustainableInvestingUrl();
    }

    return esgURL.replace("<COUNTRYCODE>", formattedCountry).replace("<LANGCODE>", formattedLanguage).replace("<ROLECODE>", formattedRole);
  },
  generateESGLearnMoreUrl: function generateESGLearnMoreUrl(country, language, role) {
    var formattedRole = role ? role.toLowerCase() : role;
    var formattedLanguage = language ? language.toLowerCase() : language;
    var formattedCountry = country ? country.toLowerCase() : country;

    var esgURL = _constants2.default.getESGInvestmentThemesSustainableInvestingESGUrl();

    if (formattedRole === 'adv') {
      if (formattedCountry === 'at' || formattedCountry === 'de' || formattedCountry === 'it' || formattedLanguage === 'de') {
        esgURL = _constants2.default.getESGInvestmentThemesSustainableInvestingUrl();
      }
      if (formattedLanguage === 'fr') {
        esgURL = _constants2.default.getESGInvestmentThemesEsgUrl();
      }
      if (formattedCountry === 'us') {
        esgURL = _constants2.default.getESGInvestmentStrategiesSustainableInvestingESGUrl();
      }
      if (formattedCountry === 'mx') {
        esgURL = _constants2.default.getESGCarbonTransitionEquityURL();
      }
      if (formattedCountry === 'au' || formattedCountry === 'hk') {
        esgURL = _constants2.default.getESGInvestmentIdeasSustainableInvestingUrlAUHK();
      }
    }

    if (formattedRole === 'per' || formattedRole === 'mps') {
      esgURL = _constants2.default.getESGInvestmentThemesEsgUrl();
      if (formattedCountry === 'it') {
        esgURL = _constants2.default.getESGInvestmentThemesSustainableInvestingUrl();
      }
      if (formattedCountry === 'us') {
        esgURL = _constants2.default.getESGInvestmentStrategiesSustainableInvestingUrl();
      }
      if (formattedCountry === 'sg') {
        esgURL = _constants2.default.getESGInvestmentIdeasSustainableInvestingUrl();
      }
      if (formattedCountry === 'jp') {
        esgURL = _constants2.default.getESGUrlJP();
      }
      if (formattedCountry === 'hk') {
        esgURL = _constants2.default.getESGInvestmentIdeasSustainableInvestingUrlAUHK();
      }
      if (formattedCountry === 'tw') {
        esgURL = _constants2.default.getESGInvestmentIdeasSustainableInvestingUrlTW();
      }
    }

    if (formattedRole === 'institutional') {
      esgURL = _constants2.default.getESGInvestmentStrategiesSustainableInvestingESGUrl();
    }

    return esgURL.replace("<COUNTRYCODE>", formattedCountry).replace("<LANGCODE>", formattedLanguage).replace("<ROLECODE>", formattedRole);
  },
  generateUSMXESGApproachLearnMoreUrl: function generateUSMXESGApproachLearnMoreUrl(country, language, role) {
    var formattedRole = role ? role.toLowerCase() : role;
    var formattedLanguage = language ? language.toLowerCase() : language;
    var formattedCountry = country ? country.toLowerCase() : country;

    var esgURL = _constants2.default.getESGInvestmentThemesSustainableInvestingUrl();

    if (formattedRole === 'adv' || formattedRole === 'per') {
      if (formattedCountry === 'us') {
        esgURL = _constants2.default.getESGInvestmentStrategiesSustainableInvestingUrl();
      }
      if (formattedCountry === 'mx') {
        esgURL = _constants2.default.getESGCarbonTransitionEquityURL();
      }
    }
    return esgURL.replace("<COUNTRYCODE>", formattedCountry).replace("<LANGCODE>", formattedLanguage).replace("<ROLECODE>", formattedRole);
  },
  validateURL: function validateURL(url) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var isEarlyNavReportURLValid, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isEarlyNavReportURLValid = false;
              _context.next = 3;
              return fetch(url);

            case 3:
              response = _context.sent;

              if (response.ok) {
                isEarlyNavReportURLValid = true;
              }

              return _context.abrupt("return", isEarlyNavReportURLValid);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

function getRegulatoryDocsBasedOnFundType(identifier, role) {
  var documentCategories = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : REGULATORY_DOCUMENT_CATEGORIES;

  var regulatoryDocuments = [];
  for (var key in documentCategories) {
    if (documentCategories.hasOwnProperty(key)) {
      var val = documentCategories[key];
      var documentObj = {};
      documentObj.title = key;
      documentObj.docURL = getDFSURL(identifier, val, role);
      regulatoryDocuments.push(documentObj);
    }
  }
  return regulatoryDocuments;
}

function getCommingledRegulatoryDocumentLinks(identifier, role) {
  var regulatoryDocumentLinks = getRegulatoryDocsBasedOnFundType(identifier, role, role === 'institutional' ? COMMINGLED_REGULATORY_DOCUMENT_CATEGORIES_INSTI : COMMINGLED_REGULATORY_DOCUMENT_CATEGORIES);
  if (role === 'institutional') {
    regulatoryDocumentLinks.forEach(function (docs) {
      if (docs.title === "Fund Summary") {
        docs.docURL += "&SPV=true";
      }
    });
    // const docs = regulatoryDocumentLinks[0];
  }
  return regulatoryDocumentLinks;
}

exports.default = UrlUtility;
var getDFSURL = UrlUtility.getDFSURL,
    getCADFSURL = UrlUtility.getCADFSURL,
    getDFSSiteForRole = UrlUtility.getDFSSiteForRole,
    generateFactSheetURLForNonUSCountry = UrlUtility.generateFactSheetURLForNonUSCountry,
    generateKIDUrl = UrlUtility.generateKIDUrl,
    generateKIIDURLForNonUSCountry = UrlUtility.generateKIIDURLForNonUSCountry,
    getLanguageOverrideForJumpToFundResults = UrlUtility.getLanguageOverrideForJumpToFundResults,
    getRegulatoryDocumentLinks = UrlUtility.getRegulatoryDocumentLinks,
    getSummaryProspectusURL = UrlUtility.getSummaryProspectusURL,
    generateFundDocLink = UrlUtility.generateFundDocLink,
    generateCostAndChargesUrl = UrlUtility.generateCostAndChargesUrl,
    getDocumentsByCategory = UrlUtility.getDocumentsByCategory,
    generateESGFindOutMoreUrl = UrlUtility.generateESGFindOutMoreUrl,
    generateESGLearnMoreUrl = UrlUtility.generateESGLearnMoreUrl,
    generateUSMXESGApproachLearnMoreUrl = UrlUtility.generateUSMXESGApproachLearnMoreUrl,
    validateURL = UrlUtility.validateURL;
exports.getDFSURL = getDFSURL;
exports.getCADFSURL = getCADFSURL;
exports.getDFSSiteForRole = getDFSSiteForRole;
exports.generateFactSheetURLForNonUSCountry = generateFactSheetURLForNonUSCountry;
exports.generateKIDUrl = generateKIDUrl;
exports.generateKIIDURLForNonUSCountry = generateKIIDURLForNonUSCountry;
exports.getLanguageOverrideForJumpToFundResults = getLanguageOverrideForJumpToFundResults;
exports.getRegulatoryDocumentLinks = getRegulatoryDocumentLinks;
exports.getSummaryProspectusURL = getSummaryProspectusURL;
exports.generateFundDocLink = generateFundDocLink;
exports.generateCostAndChargesUrl = generateCostAndChargesUrl;
exports.getDocumentsByCategory = getDocumentsByCategory;
exports.generateESGFindOutMoreUrl = generateESGFindOutMoreUrl;
exports.generateESGLearnMoreUrl = generateESGLearnMoreUrl;
exports.generateUSMXESGApproachLearnMoreUrl = generateUSMXESGApproachLearnMoreUrl;
exports.validateURL = validateURL;